import { Messages } from 'utils/forms/validations';

export const validate = (values) => {
  let errors = {};
  const keys = Object.keys(values);

  if (keys.length > 0) {
    keys.forEach((item) => {
      if (values[item]) {
        values[item].forEach((elem) => {
          if (elem.status === 'ERROR' || elem.status === 'LOAD_PENDING') {
            errors[item] = '';
          }
        });
      }
    });
  }

  if (Object.keys(errors).length) {
    errors._error = Messages.FORM_HAS_ERROR_FILES;
  }
  return errors;
};
